import { useTranslation } from 'react-i18next';
import { styled, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { getButtonSelectionOptions } from './buttonSelectionOptions';
import { ButtonSelectionTranscriptComponent } from './types';
import IntentButton from 'src/pages/solve-config/intent-button/IntentButton';

export const ButtonSelectionStep = ({
  transcriptComponent,
}: {
  transcriptComponent: ButtonSelectionTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { palette } = useTheme();
  const { from_initial_intent_id: isInitialIntent, option_selected: selected } =
    transcriptComponent;
  const options = getButtonSelectionOptions(transcriptComponent);

  return (
    <SelectionContainer>
      {isInitialIntent && (
        <Typography color={palette.colors.grey[600]} variant='font12'>
          {t('buttonSelection.initialIntent')}
        </Typography>
      )}
      <ButtonsContainer>
        {options.map(option => (
          <IntentButton
            intentName={option.label}
            isProactiveBubble={false}
            isSelected={option.value === selected}
            key={option.value}
          />
        ))}
      </ButtonsContainer>
    </SelectionContainer>
  );
};

const SelectionContainer = styled('div')`
  align-self: flex-end;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

const ButtonsContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
`;
